import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { getLocalizedMessages } from '@/translations';

const ConnectedIntlProvider = ({ locale, children }) => {
  const [messages, setMessages] = useState();

  useEffect(() => {
    setMessages(getLocalizedMessages(locale));
  }, [locale]);

  return (
    <IntlProvider
      locale={locale}
      messages={messages}
      onError={(err) => {
        if (err.code === 'MISSING_TRANSLATION' || err.code === 'MISSING_DATA') return;
        console.warn('[IntlProvider]', err.message);
      }}
    >
      {children}
    </IntlProvider>
  );
};

const mapStateToProps = state => ({
  locale: state.core.locale,
});

export default connect(mapStateToProps, null)(ConnectedIntlProvider);
